import { render } from "./HighlightedSideImage.vue?vue&type=template&id=11122df5"
import script from "./HighlightedSideImage.vue?vue&type=script&lang=js"
export * from "./HighlightedSideImage.vue?vue&type=script&lang=js"

import "./HighlightedSideImage.vue?vue&type=style&index=0&id=11122df5&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__